'use client'
import { ButtonRoundStyle, Form, RHFTextField } from '@/components'
import { requestUniversalOtp } from '@/features/auth/services'
import { identifierSchema } from '@/validations'
import yup from '@/utils/yup-global'
import { yupResolver } from '@hookform/resolvers/yup'
import { Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useTransition } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

interface IIdentifierFormProps {
  onNext: (identifier: string, type: 'email' | 'phone') => void
}

/**
 * Form component cho việc nhập email hoặc số điện thoại
 * Sẽ tự động detect loại identifier và gửi OTP
 */
export const IdentifierForm = ({ onNext }: IIdentifierFormProps) => {
  const [isPending, startTransition] = useTransition()
  const t = useTranslations('UserProfile')

  const methods = useForm<yup.InferType<typeof identifierSchema>>({
    resolver: yupResolver(identifierSchema),
  })

  const { handleSubmit } = methods

  // Detect loại identifier (email hoặc phone)
  const detectIdentifierType = (identifier: string): 'email' | 'phone' => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(identifier) ? 'email' : 'phone'
  }

  const onSubmit = (data: yup.InferType<typeof identifierSchema>) => {
    startTransition(async () => {
      try {
        const { identifier } = data
        const type = detectIdentifierType(identifier)

        // Gửi OTP
        const result = await requestUniversalOtp(identifier)

        if (result.status === 'error') {
          toast.error(result.message || 'Có lỗi xảy ra khi gửi mã OTP')
          return
        }

        onNext(identifier, type)
      } catch (error) {
        console.error('Error sending OTP:', error)
        toast.error('Có lỗi xảy ra khi gửi mã OTP')
      }
    })
  }

  return (
    <Form methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={2}>
        <RHFTextField
          name="identifier"
          label={t('Vui lòng nhập e-mail hoặc số điện thoại của bạn')}
          placeholder={t('Nhập email hoặc SĐT của bạn')}
          disabled={isPending}
          fullWidth
        />

        <ButtonRoundStyle
          variant="contained"
          type="submit"
          disabled={isPending}
          loading={isPending}
          fullWidth
        >
          {t('Gửi mã OTP')}
        </ButtonRoundStyle>
      </Stack>
    </Form>
  )
}
